import { c as _c } from "react/compiler-runtime";
import { IcoClock16 } from '@onefootprint/icons';
import { Button } from '@onefootprint/ui';
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBuilder } from '../store/provider';
import useRelativeTimestamp from './history-sidebar/use-relative-timestamp';
const PreviewFooter = () => {
  const $ = _c(34);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "agentBuilder.historicalPreview"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t0);
  const {
    state,
    setPreviewVersionId,
    restoreVersion,
    canEdit
  } = useBuilder();
  const createdAt = state.current?.createdAt;
  const versionTag = state.current?.versionTag;
  const timestamp = useRelativeTimestamp(createdAt ?? "");
  let t1;
  let t2;
  if ($[1] !== setPreviewVersionId) {
    t1 = () => {
      const onKeyDown = e => {
        if (e.key !== "Escape") {
          return;
        }
        const target = e.target as HTMLElement | null;
        if (target?.closest("input, textarea, [contenteditable=\"true\"]")) {
          return;
        }
        setPreviewVersionId(null);
      };
      window.addEventListener("keydown", onKeyDown);
      return () => window.removeEventListener("keydown", onKeyDown);
    };
    t2 = [setPreviewVersionId];
    $[1] = setPreviewVersionId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!state.current?.isHistoricalPreview || !createdAt) {
    return null;
  }
  let t3;
  if ($[4] !== t || $[5] !== timestamp || $[6] !== versionTag) {
    t3 = versionTag ? t(_temp, {
      version: versionTag,
      timestamp
    }) : t(_temp2, {
      timestamp
    });
    $[4] = t;
    $[5] = timestamp;
    $[6] = versionTag;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const label = t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: 100
    };
    t5 = {
      opacity: 1,
      y: -16
    };
    t6 = {
      opacity: 0,
      y: 100
    };
    t7 = {
      duration: 0.3
    };
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IcoClock16 className="shrink-0" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== label) {
    t9 = <span className="hidden min-w-0 items-center gap-2 text-body-3 text-secondary @md:flex">{t8}<span className="truncate">{label}</span></span>;
    $[13] = label;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = !canEdit;
  let t11;
  if ($[15] !== t) {
    t11 = t(_temp3);
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== restoreVersion || $[18] !== t10 || $[19] !== t11) {
    t12 = <Button size="compact" variant="primary" onClick={restoreVersion} disabled={t10}>{t11}</Button>;
    $[17] = restoreVersion;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== setPreviewVersionId) {
    t13 = () => setPreviewVersionId(null);
    $[21] = setPreviewVersionId;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t) {
    t14 = t(_temp4);
    $[23] = t;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13 || $[26] !== t14) {
    t15 = <Button size="compact" variant="secondary" onClick={t13}>{t14}</Button>;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t12 || $[29] !== t15) {
    t16 = <div className="flex shrink-0 items-center gap-2">{t12}{t15}</div>;
    $[28] = t12;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16 || $[32] !== t9) {
    t17 = <div className="@container pointer-events-none absolute inset-x-0 bottom-0 z-10"><motion.div className="pointer-events-auto mx-auto w-fit @md:max-w-[calc(100%-2rem)]" initial={t4} animate={t5} exit={t6} transition={t7}><footer className="flex items-center gap-3 py-2 pr-2 pl-2 @md:pl-4 border rounded-full shadow-md border-tertiary bg-primary">{t9}{t16}</footer></motion.div></div>;
    $[31] = t16;
    $[32] = t9;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
};
export default PreviewFooter;
function _temp($) {
  return $.labelWithVersion;
}
function _temp2($_0) {
  return $_0.label;
}
function _temp3($_1) {
  return $_1.restore;
}
function _temp4($_2) {
  return $_2.exit;
}